module.exports = {"data":{"site":{"siteMetadata":{"description":"Meiega äge seiklus!","title":"Seikluseksperdid OÜ","facebookUrl":"https://www.facebook.com/seikluseksperdid","instagramUrl":"https://www.instagram.com/seikluseksperdid/","email":"seiklus@seikluseksperdid.ee"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 121
// module chunks = 60335399758886 114276838955818